import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./Modal.module.css";

function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer = null,
  size = "md", // sm | md | lg
  closeOnBackdrop = true,
  closeOnEscape = true,
  showClose = true,
  keepMounted = false,
}) {
  const shouldRender = isOpen || keepMounted;

  useEffect(() => {
    if (!isOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (e) => {
      if (closeOnEscape && e.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [isOpen, closeOnEscape, onClose]);

  if (!shouldRender) return null;

  return createPortal(
    <div
      className={`${styles.overlay} ${isOpen ? styles.open : styles.closed}`}
      onMouseDown={(e) => {
        if (!closeOnBackdrop) return;
        if (e.target === e.currentTarget) onClose?.();
      }}
      aria-hidden={!isOpen}
    >
      <div
        className={`${styles.modal} ${styles[size]} ${isOpen ? styles.open : styles.closed}`}
        role="dialog"
        aria-modal="true"
        aria-label={title || "Dialog"}
      >
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          {showClose && (
            <button
              type="button"
              className={styles.closeButton}
              onClick={onClose}
              aria-label="Close"
            >
              x
            </button>
          )}
        </div>

        <div className={styles.body}>{children}</div>

        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>,
    document.body,
  );
}

export default Modal;